import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
export const SelectionActionBarIconButton = (param)=>{
    let { id, prefix, label, onSelect, type, ...restOfProps } = param;
    if (!prefix) return null;
    const trigger = /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        className: "text-pigeon-50 hover:bg-pigeon-700 active:bg-pigeon-800",
        color: "grey",
        "data-id": id,
        "data-testid": "SELECTION_ACTION_BAR_BUTTON",
        onClick: onSelect,
        size: "large",
        label: "",
        children: prefix
    });
    if (type === "item") {
        return /*#__PURE__*/ _jsx(Tooltip, {
            label: label,
            side: "top",
            children: trigger
        });
    }
    if (type === "sub" && "options" in restOfProps) {
        return /*#__PURE__*/ _jsx(Tooltip, {
            label: label,
            side: "top",
            children: /*#__PURE__*/ _jsx(DropdownMenu, {
                sideOffset: 16,
                trigger: trigger,
                children: renderDropdownItems({
                    options: restOfProps.options
                })
            })
        });
    }
    return null;
};
